var React = require('react');

function Arch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M131.412 75.9018L131.343 75.7802L1.10442 149.125L147.794 409.603L277.65 336.474L277.718 336.595C295.677 326.482 311.562 313.099 324.468 297.21C337.373 281.321 347.046 263.238 352.934 243.993C358.821 224.748 360.809 204.718 358.783 185.046C356.757 165.375 350.756 146.447 341.124 129.344C331.493 112.241 318.418 97.2969 302.647 85.3658C286.876 73.4347 268.718 64.7499 249.208 59.8073C229.699 54.8647 209.221 53.7611 188.944 56.5595C168.811 59.338 149.267 65.9093 131.412 75.9018Z","fill":"#EAC057"}));
}

Arch.defaultProps = {"width":"0","height":"0","viewBox":"0 0 415 412","fill":"none","id":"arch","className":"shape"};

module.exports = Arch;

Arch.default = Arch;
